<template>
  <div class="mm-page-main"  v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">電話卡管理</div>
      <div>
        <el-link @click="gotoruter('/AddBankPhone')" type="primary"><i class="el-icon-circle-plus"></i>添加電話卡</el-link>
      </div>
    </div>
    <search :form="form" @submit="getdata"></search>
    <div class="pagemain">

      <div class="pagetablebox">
        <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}">
          <!-- <el-table-column width="200" prop="code" label="代號" align="center"></el-table-column> -->
          <el-table-column prop="phone" label="電話號碼" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">電話號碼</div>
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="service" label="網絡提供商" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">網絡提供商</div>
              <span>{{scope.row.service}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardnum" label="關聯卡數" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">關聯卡數</div>
              <span>{{scope.row.cardnum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="餘額" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">餘額</div>
              <span>{{scope.row.money}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endtime" label="到期日期" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">到期日期</div>
              <span>{{scope.row.endtime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <el-button size="mini" @click="edit(scope.row)">編輯</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-bottom">

        <div>
          Total: {{pager.p_count}}個電話號碼
        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from "./components/SearchPhone.vue";

export default {
  components: {
    search
  },
  data () {
    return {
      mso_id:0,
      form: {
        phone: '',
        service: "",
        mso_id:0,
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
    };
  },
  methods: {
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    getdata () {
      let form = this.form;
      this.post('/api/bank/bank_phone', {
        page: this.page,
        pagesize: this.pagesize,
        ...form
      }).then((res) => {
        this.data = res.info;
        this.pager = res.pager;
      }).catch((err) => {
        this.data = [];
        this.pager = [];
        console.log(err)
      })
    },
    edit (row) {

      this.$router.push({
        name: '/EditBankPhone',
        path: '/EditBankPhone',
        params: {
          row: row
        }
      })
    },

  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    this.form.mso_id = sessionStorage.getItem('mso_id');
    this.getdata();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.radio-group-box {
  display: flex;
  align-items: center;
}
</style>
